import { useCallback, useEffect, useState } from 'react';
import { BraveBupAPI } from '@BUP/services/Axios';
import { useAuth } from '@BUP/hooks';

export const useBraveUpSurveysApi = () => {
  const { user } = useAuth();
  const { organizations } = user;
  const { id: organizationId } = organizations;

  const [listState, setListState] = useState({
    isLoading: false,
    survey: {},
    error: null,
  });

  const getData = useCallback(async () => {
    setListState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    try {
      const response = await BraveBupAPI.get(
        `/surveys?organizationId=${organizationId}`
      );

      const { data } = response?.data;
      const surv = data || {};
      const survey = surv[0];
      setListState((prevState) => ({
        ...prevState,
        survey,
      }));
    } catch (error) {
      console.log(error);
      setListState((prevState) => ({
        ...prevState,
        error,
      }));
    } finally {
      setListState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  }, [setListState, organizationId]);

  useEffect(() => {
    getData();
  }, [getData, organizationId]);

  return {
    isLoadingSurvey: listState.isLoading,
    survey: listState.survey,
    errorSurvey: listState.error,
  };
};
